module.exports = __webpack_public_path__ + "media/images/footer/pl_rp-3476de78f8feb8ab34ad7874ebf6e0be.svg";